import React, { useCallback, useEffect, useRef, useState } from "react";
import Chat from "../Chat/Chat";
import Videocard from "../VideoCard/Videocard";
import "../../main.css";

import io from "socket.io-client";
import Peer from "simple-peer";
// console.log(localStorage.getItem("accessToken"));
const socket = io.connect(process.env.REACT_APP_BACKEND_URL, {
  query: {
    token: localStorage.getItem("accessToken"),
  },
  reconnection: false,
});
export default function Home({ myName, setroute }) {
  const [stream, setstream] = useState();
  const [myId, setmyId] = useState("");
  const [caller, setCaller] = useState("");
  const [callerSignal, setCallerSignal] = useState();
  const [opponentName, setopponentName] = useState("");
  const [opponentId, setopponentId] = useState("");
  const [messageContent, setmessageContent] = useState("");
  const [messages, setmessages] = useState([]);

  const myVideo = useRef();
  const opponentVideo = useRef();
  const connectionRef = useRef();
  const [mobile, setMobile] = useState(false);

  // var socket;

  useEffect(() => {
    const handleResize = (e) => {
      // do magic for resize
      console.log(e);
      if (window.innerWidth < 768) {
        setMobile(true);
      } else {
        setMobile(false);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const toggleCam = (e) => {
    if (e.target === document.querySelector(".videocard_icon")) {
      return;
    }

    if (e.target.id === "1") {
      if (document.querySelector(".two").classList.contains("home_cam2")) {
        document.querySelector(".one").classList.toggle("home_cam2");
        document.querySelector(".one").classList.toggle("home_cam1");
        document.querySelector(".two").classList.toggle("home_cam1");
        document.querySelector(".two").classList.toggle("home_cam2");
      }
    } else {
      if (document.querySelector(".one").classList.contains("home_cam2")) {
        document.querySelector(".one").classList.toggle("home_cam2");
        document.querySelector(".one").classList.toggle("home_cam1");
        document.querySelector(".two").classList.toggle("home_cam1");
        document.querySelector(".two").classList.toggle("home_cam2");
      }
    }
  };

  const callUser = (opp, my, stream) => {
    const peer = new Peer({
      initiator: true,
      trickle: false,
      stream: stream,
    });
    peer.on("signal", (data) => {
      socket.emit("callUser", {
        userToCall: opp,
        signalData: data,
        from: my,
        name: myName,
      });
    });
    peer.on("stream", (stream) => {
      opponentVideo.current.srcObject = stream;
    });
    socket.on("callAccepted", (data) => {
      // setCallAccepted(true)
      peer.signal(data.signal);
      setopponentName(data.name);
      setCaller(data.id);
    });

    connectionRef.current = peer;
  };

  const answerCall = (gotcaller, gotsignal, stream) => {
    // setCallAccepted(true)
    const peer = new Peer({
      initiator: false,
      trickle: false,
      stream: stream,
    });
    peer.on("signal", (data) => {
      socket.emit("answerCall", { signal: data, to: gotcaller, name: myName });
    });
    peer.on("stream", (stream) => {
      opponentVideo.current.srcObject = stream;
    });
    peer.signal(gotsignal);
    connectionRef.current = peer;
  };

  const leaveCall = () => {
    // setCallEnded(true)
    // connectionRef.current.destroy()
    socket.emit("endCall", {
      opponent: caller,
    });
    window.location.reload();
  };

  const sendMessage = (e) => {
    try {
      if (messageContent !== "") {
        socket.emit("sendMessage", {
          to: caller,
          message: messageContent,
        });
        setmessages([...messages, { type: "1", content: messageContent }]);
        setmessageContent("");
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    setmyId(socket.id);
    socket.on("returOpponentId", (id) => {
      navigator.mediaDevices
        .getUserMedia({ video: true, audio: true })
        .then((stream) => {
          setstream(stream);
          myVideo.current.srcObject = stream;
          if (id) {
            callUser(id.opponent, id.myId, stream);
          }
        });
    });
    async function fetchSocket() {
      await socket.emit("getOpponetId", socket.id);
    }

    function waitforme(millisec) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve("");
        }, millisec);
      });
    }

    async function printy() {
      for (let i = 0; i < 20; ++i) {
        await waitforme(1000);

        // console.log(socket.id);
        // console.log(socket);
        if (socket.connected === true) {
          console.log("Connected");
          fetchSocket();
          break;
        } 

      }
      if(socket.connected === false){
        window.location.reload();
      }
      // console.log("Loop execution finished!)");
    }

    printy();

    socket.on("callUser", (data) => {
      // setReceivingCall(true)
      setCaller(data.from);
      setopponentName(data.name);
      setCallerSignal(data.signal);
      navigator.mediaDevices
        .getUserMedia({ video: true, audio: true })
        .then((stream) => {
          answerCall(data.from, data.signal, stream);
        });
    });

    socket.on("callEnded", () => {
      window.location.reload();
    });
  }, []);

  useEffect(() => {
    socket.on("messageReceived", (messageReceived) => {
      setmessages([...messages, { type: "2", content: messageReceived }]);
    });
  }, [messages]);

  return (
    <div className="flex h-full w-full">
      <div className={`flex ${mobile ? "flex-col" : "flex-row"} h-full w-full`}>
        <div className={`flex flex-col h-full ${mobile ? "w-full" : "w-3/4"}`}>
          {/* opponent video type 2 */}
          <div
            onClick={(e) => toggleCam(e)}
            className={`flex w-full ${
              mobile ? "h-2/3" : "h-3/4"
            } justify-center`}
          >
            <Videocard
              name={opponentName}
              videoRef={opponentVideo}
              type={"2"}
              muteEnabled=""
            />
          </div>
          {/* my video type 1 */}
          <div className="w-full h-1/4 flex flex-row justify-evenly">
            <div
              onClick={(e) => toggleCam(e)}
              className="flex w-1/3 justify-center"
            >
              <Videocard
                name={myName}
                videoRef={myVideo}
                type={"1"}
                muteEnabled="muted"
              />
            </div>
            <div className="flex flex-col items-center justify-center text-3xl">
              <div>{opponentName ? "Connected to": "Connecting.." }</div>
              <div>{opponentName}</div>{" "}
            </div>
            <div className="flex items-center">
              <button onClick={() => leaveCall()} className="btn btn-error">
                End Call
              </button>{" "}
            </div>
          </div>
        </div>
        <div className={`h-full ${mobile ? "w-full" : "w-1/4"}`}>
          <Chat
            messageContent={messageContent}
            setmessageContent={setmessageContent}
            sendMessage={sendMessage}
            messages={messages}
          />
        </div>
      </div>
    </div>
  );
}
